import { render, staticRenderFns } from "./CollectionProtocolDetail.vue?vue&type=template&id=9b9e7e5a&"
import script from "./CollectionProtocolDetail.vue?vue&type=script&lang=js&"
export * from "./CollectionProtocolDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports